module.exports = __webpack_public_path__ + "img/big_ico_center.8142d3dc.png";